import { render, staticRenderFns } from "./DFMateriality.vue?vue&type=template&id=66c98a28&"
import script from "./DFMateriality.vue?vue&type=script&lang=js&"
export * from "./DFMateriality.vue?vue&type=script&lang=js&"
import style0 from "./DFMateriality.vue?vue&type=style&index=0&id=66c98a28&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports